import { PlanItem } from "../interfaces"
import { t } from "../lib/i18n"

// 表示単位。行の値（"60GB"）と超過時の説明（"¥40 / GB"）で同じものを使う。
// 2 箇所に書くと片方だけ変わる。
export const BANDWIDTH_UNIT = "GB"
export const BUILD_TIME_UNIT = "min"

// 超過したときに何が起きるか。
//
// **プラン名では判定しません。** 判定の根拠は `plans.yml` の `price` そのもので、
// 案C v4 の CLOUD には free の bandwidth / build_time に
// `price: 0 # 従量なし（超過は停止）` と書かれています。有償 4 プランだけが
// `price > 0` で、単価はプランごとに違います（starter/basic 40・
// professional 35・enterprise 30 円 / GB）。
//
// `planType === "free"` で分けると、**price の付け方が変わった日に表示だけ
// 古くなります。** API から来た値をそのまま判定に使えば、その日に自動で
// 追随します。
export type OverageBehavior = "billed" | "stopped"

export const overageBehaviorOf = (item: PlanItem): OverageBehavior =>
  item.price > 0 ? "billed" : "stopped"

// **単価をここに書かないこと。** `item.price` を通すのが唯一の経路です
// （#418）。数値を書くと、`plans.yml` を変えても画面が古いままになります。
//
// 上限が `limited` でないときは **null（＝行ごと出さない）**。
//   - unlimited（`plans.yml` の `included: ~`）: 超える上限が無いので、
//     「超えると停止します」も「超えた分は課金」も**どちらも嘘**になります
//   - unmeasured（カタログにその価格が無い / #413）: 上限を知らないので、
//     超過したときの話を断言できません。**知らないことを 0 と読まない**のは
//     #409 / #413 / #437 と同じ族です
//
// 案C v4 の CLOUD では bandwidth / build_time の `included` は全プラン数値
// なので、実データでここに来るのは limited だけです。**それでも分岐を持つ
// のは、カタログが壊れたときに嘘を出さないためです。**
export const overageNote = (item: PlanItem, unit: string): string | null => {
  if (item.includedQuota.kind !== "limited") return null

  return overageBehaviorOf(item) === "billed"
    ? t("overage_billed", item.price.toLocaleString(), unit)
    : t("overage_stopped")
}
